module.exports = __webpack_public_path__ + "static/media/rewardsBanner.467b8a0b.webp";